// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Stats from '../components/Stats';
import Divisions from '../components/Divisions';
import News from '../components/News';
import Brands from '../components/Brands';
import Footer from '../components/Footer';
import Footer2 from '../components/Footer2';
import Life from '../components/Life'
import Video from '../components/Video'
import MissionVision from '../components/MissionVision';
import Achievements from '../components/Achievements';
import TimelineSection from '../components/TimelineSection';
import TimelineSection2 from '../components/TimelineSection2';
import FounderSection from '../components/FounderSection';
import ChairmanSection from '../components/ChairmanSection';
import DirectorSection from '../components/DirectorSection';
import Values from '../components/Values';
import DepartmentComments from '../components/DepartmentComments';
import Certification from '../components/Certification';

function Home() {
  return (
    <>
      <Hero />
      {/* <Values /> */}
      <Intro />
      <Stats />
      <Divisions />
      <Brands />
      <Video />
      <TimelineSection />
      <FounderSection />
      <ChairmanSection />
      <DirectorSection />
      <DepartmentComments />
      <Life />
      <MissionVision />
      <Certification />
      <Achievements />
      <Footer />
    </>
  );
}

export default Home;
